import React from 'react';
import MatClntCoreTransactionList from './MatClntCoreTransactionList';

export default function MatClntReturnList() {
  return (
    <MatClntCoreTransactionList
      title="Client Material - Return Transactions"
      opTypes={["return"]}
    />
  );
}
